import { DataConsts } from "./../../../../../../models/DataConsts";
import { Garantie } from "./../../../../../../models/Garantie";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { Component, Input, OnInit, ViewChild } from "@angular/core";

@Component({
  selector: "app-garantie",
  templateUrl: "./garantie.component.html",
  styleUrls: ["./garantie.component.scss"],
})
export class GarantieComponent implements OnInit {
  @ViewChild(MatPaginator, { static: false })
  paginator: MatPaginator;
  @ViewChild(MatSort, { static: false })
  sort: MatSort;
  dataSource: MatTableDataSource<Garantie>;

  @Input("garanties")
  set data(value: Garantie[]) {
    this.dataSource = new MatTableDataSource<Garantie>(value);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  favorability: string = DataConsts.FAVORABILITY;

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = [
    "id",
    "codeDossier",
    "typeGarantie",
    "montantGarantie",
    "ponderationFinale",
    "emetteurGarantie",
    "libelleSegmentPrudentielEmetteur",
    "favorability",
  ];

  constructor() {}

  ngOnInit() {}
}
